import { Panel } from 'primereact/panel';
import { LicitoCpn } from '../../../models/cpn/LicitoCpn';
import * as generic from '../../../components/Generico';
import { useForm } from 'react-hook-form';
import { InputComponent } from '../../../components/InputComponent';
import { ClientePNService } from '../../../service/ClientePNService';
import { useEffect, useState } from 'react';
import { CatalogoService } from '../../../service/CatalogoService';
import { Pago } from '../Pago';
import { ProgressSpinner } from 'primereact/progressspinner';
import { BottomActionBar } from '../../../components/ui/BottomActionBar';

export const PartebPn = ({ id, catalogos, toast, seccion, back, next, permss, soloLectura }) => {

    const esTipoEspecial = ['FRM_TOYOTA', 'FRM_DIFARE'].includes(catalogos?.tipoFrmEmpresa);
    const omodel = new LicitoCpn({ tipoFrmEmpresa: catalogos?.tipoFrmEmpresa });
    const defaultValues = generic.funDefault(omodel.model);
    const { control, formState: { errors }, handleSubmit, reset, setError, setValue } = useForm({ defaultValues });
    const { inText, inNumber, inCalendar, inDrop } = InputComponent({ omodel, errors, control, permss, id, soloLectura });
    const clientepnSrv = new ClientePNService();
    const catalogoSrv = new CatalogoService();
    const [ecuadorOL, setEcuadorOL] = useState(false);
    const [ciudadesOL, setCiudadesOL] = useState([]);
    const [isLoading, setIsLoading] = useState(true);
    const [isSaving, setIsSaving] = useState(false);

    useEffect(() => {
        editFicha();
        // eslint-disable-next-line
    }, [id]);

    const onChangePaisOL = (e) => {
        setEcuadorOL(e.value?.cat_id === catalogos.ecuador?.cat_id);
        setValue('provincia_ol', null);
        setValue('canton_ol', null);
        setValue('ciudad_ol', null);
        setCiudadesOL([]);
    }

    const onChangeProvinciaOL = (e) => {
        setValue('ciudad_ol', null);
        if (!e?.value) {
            setCiudadesOL([]);
            return;
        }
        catalogoSrv.getCatalogosId(e.value.cat_id).then(res => {
            setCiudadesOL(res.data);
        });
    }

    const editFicha = () => {
        setIsLoading(true);
        clientepnSrv.consultarClientepn(id, seccion).then(res => {
            const cats = catalogos;
            const _clientepn = res.data.clientepn;
            if (res.data.ciudades_ol) {
                setCiudadesOL(res.data.ciudades_ol);
            }
            setEcuadorOL(_clientepn.pais_ol?.cat_id === cats.ecuador?.cat_id);
            _clientepn.fecha_transaccion = generic.stringToDate(_clientepn.fecha_transaccion);
            reset(generic.renewValues(_clientepn, omodel.model));
        }).finally(() => setIsLoading(false));
    }

    const onSubmit = (data) => {
        setIsSaving(true);
        data.seccion = seccion;
        data.id = id;
        data.ec = catalogos.ecuador.cat_id;
        data.fecha_transaccion = data.fecha_transaccion.toISOString().split('T')[0];
        data.tipoFrmEmpresa = catalogos?.tipoFrmEmpresa;
        clientepnSrv.editarClientepn(data).then(res => {
            generic.funcSuccess(res, toast);
            next();
        }).catch(error => {
            generic.funcError(error, toast, setError);
        }).finally(() => setIsSaving(false));
    }

    const onError = () => {
        toast.current.show({ severity: 'error', summary: 'Error', detail: 'Se detectaron errores, por favor revise el formulario para corregir.', life: 3000 });
    }

    if (isLoading) {
        return (
            <div className="flex flex-column align-items-center justify-content-center p-5">
                <ProgressSpinner style={{ width: '50px', height: '50px' }} strokeWidth="4" animationDuration=".5s" />
                <span className="mt-3 text-color-secondary font-medium text-lg">Consultando información...</span>
            </div>
        );
    }

    return (
        <div className="fadein animation-duration-300">
            <form id="partebPnForm" onSubmit={handleSubmit(onSubmit, onError)} className="p-fluid">
                <Panel header={generic.renderPanelHeader('B.1', 'DECLARACIÓN DE ORIGEN LÍCITO DE RECURSOS', 'pi pi-money-bill')} className="panel-ficha shadow-1 mb-4">
                    <div className="col-12 mb-3 mt-2">
                        <div className="flex align-items-center">
                            <span className="text-800 font-bold text-base mr-3 flex align-items-center gap-2">
                                <i className="pi pi-file-edit text-primary"></i>
                                DATOS DE LA TRANSACCIÓN
                            </span>
                            <div className="border-bottom-1 border-300 flex-grow-1" style={{ height: '1px' }}></div>
                        </div>
                    </div>

                    <div className="formgrid grid mb-4">
                        {inText('transaccion_realiza', { icon: 'pi pi-comment' }, esTipoEspecial ? 4 : 12)}
                        {esTipoEspecial && (
                            <>
                                {inText('motivo_compra', { icon: 'pi pi-comments' }, 4)}
                                {inText('ubicacion_bien', { icon: 'pi pi-map-marker' }, 4)}
                            </>
                        )}
                        {inDrop('moneda', catalogos?.moneda, { lab: omodel.optionLabel }, 6)}
                        {inNumber('valor_total_bien_servicio', 2, true, { icon: 'pi pi-dollar', iconPosition: 'left' }, 6)}

                        <div className="col-12 mt-2 mb-2">
                            <div className="border-top-1 border-300"></div>
                        </div>

                        {inDrop('pais_ol', catalogos?.pais, { lab: omodel.optionLabel, chn: onChangePaisOL }, ecuadorOL ? 3 : 4)}
                        {ecuadorOL ? (
                            <>
                                {inDrop('provincia_ol', catalogos?.provincias, { lab: omodel.optionLabel, chn: onChangeProvinciaOL }, 3)}
                                {inDrop('ciudad_ol', ciudadesOL, { lab: omodel.optionLabel }, 3)}
                            </>
                        ) : (
                            inText('canton_ol', { icon: 'pi pi-map-marker' }, 4)
                        )}

                        {inCalendar('fecha_transaccion', {}, ecuadorOL ? 3 : 4)}
                    </div>

                    <div className="col-12 mb-3 mt-3">
                        <div className="flex align-items-center">
                            <span className="text-800 font-bold text-base mr-3 flex align-items-center gap-2">
                                <i className="pi pi-wallet text-primary"></i>
                                FORMA DE PAGO
                            </span>
                            <div className="border-bottom-1 border-300 flex-grow-1" style={{ height: '1px' }}></div>
                        </div>
                    </div>

                    <div className="col-12 px-0">
                        <Pago toast={toast} tipo={'clientePn'} id={id} permss={permss} soloLectura={soloLectura} tipoFrmEmpresa={catalogos?.tipoFrmEmpresa} />
                    </div>
                </Panel>

                <BottomActionBar formId="partebPnForm" onPrev={back} onNext={next} loading={isSaving} isReadOnly={soloLectura} />
            </form>
        </div>
    )
}
